/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EDocumentType } from "../types/EDocumentType.ts";

/**
 * @description 0 = CourseDocument | 1 = Syllabus | 2 = Contract | 3 = Manual | 4 = MonographDefense | 5 = FinishCourseCertificate | 6 = UspDocument | 7 = Regiment |
 */
export const eDocumentTypeSchema = z
  .union([
    z.literal(0),
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
  ])
  .describe(
    "0 = CourseDocument | 1 = Syllabus | 2 = Contract | 3 = Manual | 4 = MonographDefense | 5 = FinishCourseCertificate | 6 = UspDocument | 7 = Regiment | ",
  ) as unknown as ToZod<EDocumentType>;
